import React from 'react';
import logo from "../components/assets/GLOBALPHOENIXLOGO.png"

const Footer = () => {
  return (
    <footer className="bg-[#1a1f2e] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <div className="bg-white p-1.5 rounded-lg flex-shrink-0">
                <img src={logo} alt="Logo" className="w-11 h-11 object-contain" />
              </div>
              <h3 className="text-2xl font-bold leading-tight">
                Global Phoenix<br />Pharmaceuticals
              </h3>
            </div>
            <p className="text-base text-gray-400 mb-8 leading-relaxed">
              Pharmaceutical distributors and exporters delivering quality medicines with competitive pricing and a reliable global supply chain.
            </p>

            {/* Follow Us Section */}
            <div>
              <h5 className="text-base md:text-base font-bold mb-4 text-white">Follow Us</h5>
              <div className="flex space-x-3">
                <a href="#" className="w-9 h-9 bg-[#2a303f] rounded flex items-center justify-center hover:bg-[#1b8eb7] transition-colors">
                  <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                  </svg>
                </a>
                <a href="#" className="w-9 h-9 bg-[#2a303f] rounded flex items-center justify-center hover:bg-[#1b8eb7] transition-colors">
                  <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z" />
                  </svg>
                </a>
                <a href="#" className="w-9 h-9 bg-[#2a303f] rounded flex items-center justify-center hover:bg-[#1b8eb7] transition-colors">
                  <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:pl-8">
            <h4 className="text-base md:text-base font-bold mb-6">Quick Links</h4>
            <ul className="space-y-4">
              <li><a href="/" className="text-base text-gray-400 hover:text-white transition-colors">Home</a></li>
              <li><a href="/about" className="text-base text-gray-400 hover:text-white transition-colors">About Us</a></li>
              <li><a href="/services" className="text-base text-gray-400 hover:text-white transition-colors">Services</a></li>
              <li><a href="/contact" className="text-base text-gray-400 hover:text-white transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Wholesale Services */}
          <div>
            <h4 className="text-base md:text-base font-bold mb-6">Wholesale Services</h4>
            <ul className="space-y-4">
              <li><a href="#" className="text-base text-gray-400 hover:text-white transition-colors">Bulk Order Management</a></li>
              <li><a href="#" className="text-base text-gray-400 hover:text-white transition-colors">Distributor Network</a></li>
              <li><a href="#" className="text-base text-gray-400 hover:text-white transition-colors">Credit Management</a></li>
              <li><a href="#" className="text-base text-gray-400 hover:text-white transition-colors">Price Analytics</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-base md:text-base font-bold mb-6">Contact Info</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-[#2a303f] rounded flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div>
                  <p className="text-base text-gray-300 font-medium">Global Phoenix</p>
                  <p className="text-base text-gray-300 font-medium">Pharmaceuticals, Sulthan</p>
                  <p className="text-base text-gray-300 font-medium">Bathery</p>
                  <p className="text-sm text-gray-400 mt-1">Wayanad, Kerala 673592, India</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-[#2a303f] rounded flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <p className="text-base text-gray-300">+91 9048762636</p>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-[#2a303f] rounded flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <p className="text-base text-gray-300">globalphoenix2025@gmail.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-800 bg-[#161a23]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="text-gray-400 text-xs md:text-sm text-center md:text-left">
            © 2025 Global Phoenix Pharmaceuticals. All rights reserved. | Empowering Healthcare Commerce
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
